import React from 'react';
import { Box, Container, Heading, Tabs, TabList, TabPanels, Tab, TabPanel, Text } from '@chakra-ui/react';
import { useTranslation } from '../../translations/useTranslation';
import EnhancedWeatherForecast from './EnhancedWeatherForecast';
import './Weather.css';

const WeatherPage = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Container maxW="container.xl" my={4}>
        <Heading as="h1" size="xl" mb={4}>{t('weatherForecast')}</Heading>
        
        <Tabs variant="soft-rounded" colorScheme="green" mb={6}>
          <TabList>
            <Tab>{t('generalForecast')}</Tab>
            <Tab>{t('cropSpecific')}</Tab>
            <Tab>{t('weatherAlerts')}</Tab>
          </TabList>
          
          <TabPanels>
            <TabPanel>
              <EnhancedWeatherForecast />
            </TabPanel>
            
            <TabPanel>
              <Box p={4} borderRadius="lg" bg="white" boxShadow="md">
                <Heading as="h3" size="md" mb={4}>{t('cropSpecificRecommendations')}</Heading>
                
                <Tabs variant="enclosed" size="sm">
                  <TabList>
                    <Tab>{t('rice')}</Tab>
                    <Tab>{t('wheat')}</Tab>
                    <Tab>{t('corn')}</Tab>
                    <Tab>{t('vegetables')}</Tab>
                    <Tab>{t('fruits')}</Tab>
                  </TabList>
                  
                  <TabPanels>
                    <TabPanel>
                      <Box>
                        <Heading as="h4" size="sm" mb={2}>{t('riceCultivationAdvice')}</Heading>
                        <ul>
                          <li>{t('riceTip1')}</li>
                          <li>{t('riceTip2')}</li>
                          <li>{t('riceTip3')}</li>
                        </ul>
                      </Box>
                    </TabPanel>
                    
                    <TabPanel>
                      <Box>
                        <Heading as="h4" size="sm" mb={2}>{t('wheatCultivationAdvice')}</Heading>
                        <ul>
                          <li>{t('wheatTip1')}</li>
                          <li>{t('wheatTip2')}</li>
                          <li>{t('wheatTip3')}</li>
                        </ul>
                      </Box>
                    </TabPanel>
                    
                    <TabPanel>
                      <Box>
                        <Heading as="h4" size="sm" mb={2}>{t('cornCultivationAdvice')}</Heading>
                        <ul>
                          <li>{t('cornTip1')}</li>
                          <li>{t('cornTip2')}</li>
                          <li>{t('cornTip3')}</li>
                        </ul>
                      </Box>
                    </TabPanel>
                    
                    <TabPanel>
                      <Box>
                        <Heading as="h4" size="sm" mb={2}>{t('vegetableCultivationAdvice')}</Heading>
                        <ul>
                          <li>{t('vegetableTip1')}</li>
                          <li>{t('vegetableTip2')}</li>
                          <li>{t('vegetableTip3')}</li>
                        </ul>
                      </Box>
                    </TabPanel>
                    
                    <TabPanel>
                      <Box>
                        <Heading as="h4" size="sm" mb={2}>{t('fruitCultivationAdvice')}</Heading>
                        <ul>
                          <li>{t('fruitTip1')}</li>
                          <li>{t('fruitTip2')}</li>
                          <li>{t('fruitTip3')}</li>
                        </ul>
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Box>
            </TabPanel>
            
            <TabPanel>
              <Box p={4} borderRadius="lg" bg="white" boxShadow="md">
                <Heading as="h3" size="md" mb={4}>{t('weatherAlerts')}</Heading>
                <Box p={3} bg="yellow.50" borderRadius="md" mb={3}>
                  <Heading as="h4" size="sm" color="yellow.700">{t('moderateRainExpected')}</Heading>
                  <Text mt={1}>{t('moderateRainDescription')}</Text>
                </Box>
                
                <Box p={3} bg="blue.50" borderRadius="md">
                  <Heading as="h4" size="sm" color="blue.700">{t('temperatureFluctuation')}</Heading>
                  <Text mt={1}>{t('temperatureFluctuationDescription')}</Text>
                </Box>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </Box>
  );
};

export default WeatherPage;